import { loadCovidStatistics, saveItinerary, searchTravelDetails } from 'actions/searchActions';
import AppPageHeader from 'components/common/AppPageHeader';
import PageContainer from 'components/common/PageContainer';
import PageRow from 'components/common/PageRow';
import { add, format } from 'date-fns';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TripEntry } from 'services/dataService';
import toaster from '../../helpers/uiHelper';
import CovidStatistics from './components/CovidStatistics';
import MapPanel from './components/MapPanel';
import MultiSearchPanel from './components/MultiSearchPanel';
import TravelDetails from './components/travel_details/TravelDetails';
import extras, { SUMMARY_TAB } from './extras';





function ExplorePage() {
  const dispatch = useDispatch();
  const tomorrow = add(new Date(), { years: 0, months: 0, weeks: 0, days: 1, hours: 0, minutes: 0, seconds: 0 })
  const newDate = format(tomorrow, 'yyyy-MM-dd');
  const [searchDetails, setSearchDetails] = useState([ {from: '', to: '', departure: newDate, index: 0, last: true} ] as TripEntry[]);

  const [travelDetails, setTravelDetails] = useState({});
  const [isActiveSave, setIsActiveSave] = useState(false);
  const [isActiveAdd, setIsActiveAdd] = useState(true);
  const [resultID, setResultID] = useState('');

  const [covidStatistics, setCovidStatistics] = useState([]);

  function onSearchChange(index, field, value) {
    let temp = [...searchDetails];
    
    while (temp.length <= index) {
      temp.push({} as TripEntry);
    }

    for (let i = 0; i < temp.length; i++) {
      if (i === temp.length - 1) {
        temp[i].last = true;
      } else {
        temp[i].last = false;
      }
    }

    temp[index][field] = value;
    setSearchDetails(temp);
    setIsActiveSave(false);
  }

  function onAdd() {
    let temp = [...searchDetails];
    
    if (temp.length < 3) {
      temp.push({ from: '', to: '', departure: newDate, index: temp.length,last: true } as TripEntry);
      temp[temp.length - 2].last = false;
    }

    
    setSearchDetails(temp);
    
    if (temp.length >= 3) {
      setIsActiveAdd(false);
    }    
  }

  function onSub() {
    let temp = [...searchDetails];
    
    if (temp.length > 1) {
      temp.pop();
      temp[temp.length - 1].last = true;
    }

    
    setSearchDetails(temp);
    
    if (temp.length < 3) {
      setIsActiveAdd(true);
    }
    
  }

  async function travelSearch() {
    if (!isSearchActive()) return;

    let result: any = await dispatch(searchTravelDetails(searchDetails));

    if (result) {
      let details = extras.mapTravelDetails(result);

      setTravelDetails(details);
      if (typeof result?.id === 'string') {
        setResultID(result.id);
      }
      
      setIsActiveSave(true);

      await loadCovidStats(details[SUMMARY_TAB].countryCode);
    }
  }

  async function loadCovidStats(countryCode) {
    let data = await dispatch(loadCovidStatistics(countryCode));

    if (data) {
      let stats = extras.mapCovidData(data[countryCode]);

      setCovidStatistics(stats);
    }
  }

  async function onSave() {
    if (!isActiveSave) return;

    let result: any = await dispatch(saveItinerary(resultID));
    console.log("saved itinerary", result);
    if (result?.id) {
      toaster.showMessage("Your itinerary has been saved!");
      setResultID('');
    } else {
      toaster.showError("Sorry, we couldn't save your itinerary, please try again.");
    }
  }

  function isSearchActive() {
    if (searchDetails.length === 0) {
      return false;
    }
    return searchDetails[0].from && searchDetails[0].to ? true : false;
  }

  function getCoordinates() {
    let data = travelDetails[SUMMARY_TAB];

    if (!data) return null;

    return {latitude: Number(data.latitude), longitude: Number(data.longitude)};
  }

  function render() {
    let isActiveSearch = isSearchActive();
    

    let coordinates = getCoordinates();

    return (
      <PageContainer>
        <AppPageHeader title="Explore" />

        <PageRow>
          <MultiSearchPanel
            searchDetails={searchDetails}
            isActiveSearch={isActiveSearch}
            isActiveSave={isActiveSave}
            isActiveAdd={isActiveAdd}
            onChange={onSearchChange}
            onSearch={travelSearch}
            onSave={onSave}
            onAdd={onAdd}
            onSub={onSub}
          />
        </PageRow>

        <PageRow>
          <TravelDetails travelDetails={travelDetails} />

          <div>
            <MapPanel coordinates={coordinates} />
            <CovidStatistics statistics={covidStatistics} />
          </div>
        </PageRow>
      </PageContainer>
    );
  }

  return render();
}

export default ExplorePage;
